<table class="table table-muted mb-0">
  <thead>
    <tr>
      <th>
        <a (click)="sort($event, 'location')">Location
          <i *ngIf="orderField === 'location' && order" class="fa"
            [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}">
          </i>
        </a>
      </th>
      <th *ngIf="!tender.company.settings.isHiddenField('location_company')">
        Company
      </th>
      <th *ngIf="!tender.company.settings.isHiddenField('location_fuel_type')">
        Fuel Type
      </th>
      <th *ngIf="!tender.company.settings.isHiddenField('location_flight_type')">
        Flight Type
      </th>
      <th *ngIf="!tender.company.settings.isHiddenField('location_delivery_point')">
        Delivery Point
      </th>
      <th>
        <a (click)="sort($event, 'volume')">Yearly Volume
          <i *ngIf="orderField === 'volume' && order" class="fa"
            [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}">
          </i>
        </a>
      </th>
      <th>
        Tags
      </th>
      <th>
        Round
      </th>
      <th class="text-center">
        <a (click)="sort($event, 'status')">Status
          <i *ngIf="orderField === 'status' && order" class="fa"
            [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}">
          </i>
        </a>
      </th>
      <th class="text-center">
        Bids Submitted
      </th>
      <th>
        Settings
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor='let contract of contracts'>
      <td>
        <div class="td d-flex align-items-center">
          <strong>{{ contract.location.iata }}</strong>
        </div>
      </td>
      <td data-label="Company" *ngIf="!tender.company.settings.isHiddenField('location_company')">
        <span *ngIf="contract.companyChild && contract.companyChild?.name">{{ contract.companyChild?.getDisplayName()
          }}</span>
        <span *ngIf="!(contract.companyChild && contract.companyChild?.name)">{{ contract.companyInfo }}</span>
      </td>
      <td data-label="Fuel Type" *ngIf="!tender.company.settings.isHiddenField('location_fuel_type')">
        <span *ngIf="contract.fuelType?.name">{{tender.company.settings.getFilteredOptionLabel('fuel_type',
          contract.fuelType)}}</span>
        <span *ngIf="!contract.fuelType?.name" class="small text-muted">
          Not Provided
        </span>
      </td>
      <td data-label="Flight Type" *ngIf="!tender.company.settings.isHiddenField('location_flight_type')">
        <span *ngIf="contract.flightType?.name">{{contract.flightType.name}}</span>
      </td>
      <td data-label="Delivery Point" *ngIf="!tender.company.settings.isHiddenField('location_delivery_point')">
        <span *ngIf="contract.fuelPreference?.name">{{tender.company.settings.getFilteredOptionLabel('delivery_point',
          contract.fuelPreference)}}</span>
      </td>
      <td data-label="Yearly Volume">
        {{ contract.volume | number : '1.0-0' | usNumber }}
      </td>
      <td data-label="Tags">
        <span *ngFor="let tag of contract.tags">
          <span
            class="badge py-1 px-2 me-2 text-warning-emphasis bg-warning-subtle border border-warning-subtle rounded-pill">
            {{tag['name']}}
          </span>
        </span>
      </td>
      <td data-label="Round">
        <jft-time-remaining [round]="contract.currentRound"></jft-time-remaining>
      </td>
      <td data-label="Status">
        <jft-round-status [status]="contract.currentRound.status"></jft-round-status>
      </td>
      <td data-label="Bids Submitted" class="text-center">
        {{contract.currentRound.bidsSubmitted}}
      </td>
      <td class="mobile-full">
        <ng-template #tipContent>
          <div class="text-start">
            <div *ngIf="contract.dateStart">
              Contract start date: <strong>{{contract.dateStart | date:'dd MMM yyyy':'UTC'}}</strong><br>
            </div>
            <div *ngIf="contract.dateEnd">
              Contract end date: <strong>{{contract.dateEnd | date:'dd MMM yyyy':'UTC'}}</strong><br>
            </div>
            <div *ngIf="contract.currency?.code">
              Preferred currency: <strong>{{contract.currency.code}}</strong><br>
            </div>
            <div *ngIf="contract.units?.code">
              Preferred units: <strong>{{contract.units.code}}</strong><br><br>
            </div>

            <div
              *ngIf="!tender.company.settings.isHiddenField('location_annual_frequency') && contract.annualFrequency">
              Annual Frequency: <strong>{{contract.annualFrequency}}</strong><br>
            </div>
            <div *ngIf="!tender.company.settings.isHiddenField('location_average_uplift') && contract.averageUplift">
              Average uplift: <strong>{{contract.averageUplift}}</strong><br>
            </div>
            <div *ngIf="!tender.company.settings.isHiddenField('location_months_of_service') && contract.monthService">
              Months of service: <strong>{{contract.monthService}}</strong><br>
            </div>
            <div
              *ngIf="!tender.company.settings.isHiddenField('location_monthly_volume') && contract.monthService && contract.volume">
              Monthly volume: <strong>{{contract.volume / contract.monthService | number : '1.0-0' | usNumber }} {{
                contract.units.code }}</strong><br>
            </div>
            <div *ngIf="!tender.company.settings.isHiddenField('location_award_quota') && contract.awardQuota">
              Award quota: <strong>{{ contract.awardQuota }}%</strong><br>
            </div>
            <div *ngIf="!tender.company.settings.isHiddenField('location_branded')">
              Branded: <strong>{{ contract.branded ? 'Yes' : 'No' }}</strong><br>
            </div>

            <div *ngIf="!tender.company.settings.isHiddenField('location_notes') && contract.notes">
              <br>
              Location Specific Notes:<br>{{contract.notes}}<br>
            </div>
          </div>
        </ng-template>
        <a href="javascript:void(0);" placement="left" [ngbTooltip]="tipContent">
          <i class="fas fa-sliders-h"></i>
        </a>
      </td>
    </tr>

    <!-- Empty state -->
    <tr *ngIf="!contracts.length && !loading" class="mobile-plain">
      <td colspan="9">
        <p class="text-center small my-5">No locations found</p>
      </td>
    </tr>

    <!-- Loading placeholders -->
    <tr *ngIf="loading" class="placeholder-glow mobile-plain">
      <td><span class="placeholder col-2"></span></td>
      <td><span class="placeholder col-8"></span></td>
      <td><span class="placeholder col-6"></span></td>
      <td><span class="placeholder col-5"></span></td>
      <td><span class="placeholder col-7"></span></td>
      <td><span class="placeholder col-4"></span></td>
      <td><span class="placeholder col-6"></span></td>
      <td><span class="placeholder col-5"></span></td>
      <td><span class="placeholder col-3"></span></td>
    </tr>
    <tr *ngIf="loading" class="placeholder-glow mobile-plain">
      <td><span class="placeholder col-2"></span></td>
      <td><span class="placeholder col-7"></span></td>
      <td><span class="placeholder col-5"></span></td>
      <td><span class="placeholder col-6"></span></td>
      <td><span class="placeholder col-8"></span></td>
      <td><span class="placeholder col-4"></span></td>
      <td><span class="placeholder col-5"></span></td>
      <td><span class="placeholder col-6"></span></td>
      <td><span class="placeholder col-3"></span></td>
    </tr>
    <tr *ngIf="loading" class="placeholder-glow mobile-plain">
      <td><span class="placeholder col-2"></span></td>
      <td><span class="placeholder col-9"></span></td>
      <td><span class="placeholder col-4"></span></td>
      <td><span class="placeholder col-7"></span></td>
      <td><span class="placeholder col-6"></span></td>
      <td><span class="placeholder col-4"></span></td>
      <td><span class="placeholder col-7"></span></td>
      <td><span class="placeholder col-5"></span></td>
      <td><span class="placeholder col-3"></span></td>
    </tr>
  </tbody>
</table>